/**
 * Zone merkle proof lookup service.
 *
 * Loads the pre-generated merkle tree and provides proof generation
 * for startFarm transactions.
 */

import { StandardMerkleTree } from "@openzeppelin/merkle-tree";
import treeDump from "../data/zone-merkle-tree.json";

// Load the merkle tree from the pre-generated dump
const tree = StandardMerkleTree.load(treeDump as ReturnType<StandardMerkleTree<[number, number]>["dump"]>);

/** Merkle root (bytes32) for contract configuration. */
export const ZONE_MERKLE_ROOT = tree.root as `0x${string}`;

/** Get zone and merkle proof for a system index. */
export function getZoneProof(systemIndex: number): {
	zone: number;
	proof: `0x${string}`[];
} {
	for (const [i, value] of tree.entries()) {
		const [sysIdx, zone] = value as [number, number];
		if (sysIdx === systemIndex) {
			return {
				zone,
				proof: tree.getProof(i) as `0x${string}`[],
			};
		}
	}
	throw new Error(`System index ${systemIndex} not found in merkle tree`);
}
